// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3z9lm","col":"Table_col__1jJNI","fulfillmentStatus":"Table_fulfillmentStatus__2w0zB","emailCol":"Table_emailCol__3Olf1"};